export function UploadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"
        fill="#7E00FD"
      />
    </svg>
  )
}

export function NoteIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 7.5H12.5"
        stroke="#7E00FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10H12.5"
        stroke="#7E00FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.5H10"
        stroke="#7E00FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2411 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H16.25C16.4158 3.125 16.5747 3.19085 16.6919 3.30806C16.8092 3.42527 16.875 3.58424 16.875 3.75V12.2411C16.875 12.3232 16.8588 12.4045 16.8274 12.4803C16.796 12.5561 16.75 12.625 16.6919 12.6831L12.6831 16.6919C12.625 16.75 12.5561 16.796 12.4803 16.8274C12.4045 16.8588 12.3232 16.875 12.2411 16.875V16.875Z"
        stroke="#7E00FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8184 12.5H12.5V16.8187"
        stroke="#7E00FD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function DocumentIcon() {
  return (
    <svg className='document'
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6V1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V7.5H10.5C10.1022 7.5 9.72065 7.34196 9.43934 7.06066C9.15804 6.77936 9 6.39782 9 6ZM5.25 9.1875C5.25 9.03832 5.30926 8.89524 5.41475 8.78975C5.52024 8.68426 5.66332 8.625 5.8125 8.625C5.96168 8.625 6.10476 8.68426 6.21025 8.78975C6.31574 8.89524 6.375 9.03832 6.375 9.1875C6.375 9.33668 6.31574 9.47976 6.21025 9.58525C6.10476 9.69074 5.96168 9.75 5.8125 9.75C5.66332 9.75 5.52024 9.69074 5.41475 9.58525C5.30926 9.47976 5.25 9.33668 5.25 9.1875ZM5.25 11.4375C5.25 11.2883 5.30926 11.1452 5.41475 11.0398C5.52024 10.9343 5.66332 10.875 5.8125 10.875C5.96168 10.875 6.10476 10.9343 6.21025 11.0398C6.31574 11.1452 6.375 11.2883 6.375 11.4375C6.375 11.5867 6.31574 11.7298 6.21025 11.8352C6.10476 11.9407 5.96168 12 5.8125 12C5.66332 12 5.52024 11.9407 5.41475 11.8352C5.30926 11.7298 5.25 11.5867 5.25 11.4375ZM5.25 13.6875C5.25 13.5383 5.30926 13.3952 5.41475 13.2898C5.52024 13.1843 5.66332 13.125 5.8125 13.125C5.96168 13.125 6.10476 13.1843 6.21025 13.2898C6.31574 13.3952 6.375 13.5383 6.375 13.6875C6.375 13.8367 6.31574 13.9798 6.21025 14.0852C6.10476 14.1907 5.96168 14.25 5.8125 14.25C5.66332 14.25 5.52024 14.1907 5.41475 14.0852C5.30926 13.9798 5.25 13.8367 5.25 13.6875ZM7.5 9.1875C7.5 9.03832 7.55926 8.89524 7.66475 8.78975C7.77024 8.68426 7.91332 8.625 8.0625 8.625H12.1875C12.3367 8.625 12.4798 8.68426 12.5852 8.78975C12.6907 8.89524 12.75 9.03832 12.75 9.1875C12.75 9.33668 12.6907 9.47976 12.5852 9.58525C12.4798 9.69074 12.3367 9.75 12.1875 9.75H8.0625C7.91332 9.75 7.77024 9.69074 7.66475 9.58525C7.55926 9.47976 7.5 9.33668 7.5 9.1875ZM7.5 11.4375C7.5 11.2883 7.55926 11.1452 7.66475 11.0398C7.77024 10.9343 7.91332 10.875 8.0625 10.875H12.1875C12.3367 10.875 12.4798 10.9343 12.5852 11.0398C12.6907 11.1452 12.75 11.2883 12.75 11.4375C12.75 11.5867 12.6907 11.7298 12.5852 11.8352C12.4798 11.9407 12.3367 12 12.1875 12H8.0625C7.91332 12 7.77024 11.9407 7.66475 11.8352C7.55926 11.7298 7.5 11.5867 7.5 11.4375ZM7.5 13.6875C7.5 13.5383 7.55926 13.3952 7.66475 13.2898C7.77024 13.1843 7.91332 13.125 8.0625 13.125H12.1875C12.3367 13.125 12.4798 13.1843 12.5852 13.2898C12.6907 13.3952 12.75 13.5383 12.75 13.6875C12.75 13.8367 12.6907 13.9798 12.5852 14.0852C12.4798 14.1907 12.3367 14.25 12.1875 14.25H8.0625C7.91332 14.25 7.77024 14.1907 7.66475 14.0852C7.55926 13.9798 7.5 13.8367 7.5 13.6875ZM10.125 6V1.875L14.625 6.375H10.5C10.4005 6.375 10.3052 6.33549 10.2348 6.26516C10.1645 6.19484 10.125 6.09946 10.125 6Z"
        fill="#7E00FD"
      />
    </svg>
  )
}
export function MailIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5375 15.9675C13.4681 16.037 13.3857 16.0922 13.295 16.1298C13.2042 16.1675 13.107 16.1868 13.0087 16.1868C12.9105 16.1868 12.8133 16.1675 12.7225 16.1298C12.6318 16.0922 12.5494 16.037 12.48 15.9675L10.89 14.3775C10.8206 14.3081 10.7655 14.2256 10.7279 14.1349C10.6903 14.0442 10.671 13.9469 10.671 13.8488C10.671 13.7506 10.6903 13.6533 10.7279 13.5626C10.7655 13.4719 10.8206 13.3894 10.89 13.32C11.0302 13.1798 11.2204 13.101 11.4188 13.101C11.5169 13.101 11.6142 13.1203 11.7049 13.1579C11.7956 13.1955 11.8781 13.2506 11.9475 13.32L13.005 14.3775L15.66 11.7225C15.7294 11.6531 15.8119 11.598 15.9026 11.5604C15.9933 11.5228 16.0906 11.5035 16.1888 11.5035C16.2869 11.5035 16.3842 11.5228 16.4749 11.5604C16.5656 11.598 16.6481 11.6531 16.7175 11.7225C16.7869 11.7919 16.842 11.8744 16.8796 11.9651C16.9172 12.0558 16.9365 12.1531 16.9365 12.2512C16.9365 12.3494 16.9172 12.4467 16.8796 12.5374C16.842 12.6281 16.7869 12.7106 16.7175 12.78L13.5375 15.9675ZM9.06 15H3C2.175 15 1.5 14.325 1.5 13.5V4.5C1.5 3.675 2.175 3 3 3H15C15.825 3 16.5 3.675 16.5 4.5V9.51C15.7001 9.12948 14.817 8.95768 13.9328 9.01061C13.0486 9.06353 12.1922 9.33946 11.4435 9.81268C10.6947 10.2859 10.0779 10.941 9.65068 11.7169C9.22343 12.4928 8.99958 13.3642 9 14.25C9 14.505 9.0225 14.7525 9.06 15ZM8.6025 9.5025C8.8425 9.6525 9.1575 9.6525 9.3975 9.5025L14.7 6.1875C14.7752 6.14528 14.8411 6.08825 14.8936 6.01984C14.9461 5.95143 14.9842 5.87308 15.0056 5.78953C15.0269 5.70597 15.0311 5.61895 15.0179 5.53373C15.0046 5.44851 14.9742 5.36686 14.9285 5.29373C14.8828 5.22059 14.8228 5.15749 14.752 5.10825C14.6812 5.059 14.6011 5.02463 14.5166 5.00722C14.4322 4.98981 14.345 4.98973 14.2605 5.00696C14.176 5.0242 14.0959 5.0584 14.025 5.1075L9 8.25L3.975 5.1075C3.9041 5.0584 3.82397 5.0242 3.73947 5.00696C3.65496 4.98973 3.56784 4.98981 3.48337 5.00722C3.3989 5.02463 3.31885 5.059 3.24804 5.10825C3.17724 5.15749 3.11717 5.22059 3.07146 5.29373C3.02575 5.36686 2.99536 5.44851 2.98212 5.53373C2.96888 5.61895 2.97307 5.70597 2.99443 5.78953C3.0158 5.87308 3.05389 5.95143 3.10642 6.01984C3.15894 6.08825 3.2248 6.14528 3.3 6.1875L8.6025 9.5025Z"
        fill="#7E00FD"
      />
    </svg>
  )
}
